module.exports = __webpack_public_path__ + "img/service-3.f4d4ede9.png";